import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class ApplicantService extends AbstractService {
	static endpoint = ENDPOINTS.applications;

	static externalOfficersApi = NexusService.externalOfficersApi;

	static update(
		{ assign, jobId, userId, accept, toReassign, updateAllRecurrenceJob = "" },
		queryParams,
	) {
		const assignJob = assign && assign === true;

		return this.request({
			endpoint: `${this.endpoint}${!assignJob && accept === undefined ? `/${jobId}` : ""}`,
			queryParams,
			method: assignJob ? "POST" : "PUT",
			data: {
				jobId,
				userId,
				accept,
				updateAllRecurrenceJob,
				assignJob: assign ? assignJob : undefined,
				overRuleAssignment: toReassign || undefined,
			},
		});
	}

	static assignOfficer(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/assign`,
			queryParams,
			data,
		});
	}

	static unAssignOfficer(jobId, queryParams, data) {
		return this.put({
			endpoint: `${this.endpoint}/${jobId}`,
			queryParams,
			data,
		});
	}

	static assignExternalOfficer(data) {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_external_officers")) {
			const request = {
				externalOfficerAssignmentCreatePayload: {},
			};
			if (Object.hasOwn(data, "jobId")) {
				request.externalOfficerAssignmentCreatePayload.JobId = data.jobId;
			}
			if (Object.hasOwn(data, "officerName")) {
				request.externalOfficerAssignmentCreatePayload.OfficerName = data.officerName;
			}
			return this.externalOfficersApi.assignExternalOfficer(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.post({
			endpoint: ENDPOINTS.externalOfficers,
			data,
		});
	}

	static unAssignExternalOfficer(userId) {
		if (FeatureFlagService.isEnabled("use_api_core_endpoints_external_officers")) {
			const request = {
				id: userId,
			};
			return this.externalOfficersApi.deleteExternalOfficer(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.del({
			endpoint: `${ENDPOINTS.externalOfficers}/${userId}`,
		});
	}
}
